/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { organsAPI } from 'src/api/modules/organs';
import { sessionsAPI } from 'src/api/modules/sessions';
import FullTable from 'src/common/components/FullTable';
import notice from 'src/common/components/Notice';
import PageLayout from 'src/common/components/PageLayout';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { columns, defaultFilter, filterForm } from './utils/list_data';
import { startLog } from 'src/api/modules/bitacora';
import DeleteConsultModal from './DeleteConsultModal';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { formatDate } from 'src/utils/dates';
import { usePagination } from 'src/hooks/usePagination';

const ConsultSessions = () => {
	const history = useHistory();
	const location = useLocation();
	const filial = localStorage.getItem('type');
	const [filter, setFilter] = useState(defaultFilter);
	const [sessions, setSessions] = useState([]);
	const [organs, setOrgans] = useState([]);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const [modalDelete, setModalDelate] = useState(false);
	const [mounted, setMounted] = useState(false);
	const [idSess, setIdSess] = useState();
	const [canRemove, setCanRemove] = useState(false);
	const [loading, setLoading] = useState(false);
	const {
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
		handlePagination,
	} = usePagination();
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];
	const removeSession = [
		'ADMINISTRADOR GENERAL',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
		'RESPONSABLE DE ORGANO COLEGIADO',
	];

	useEffect(() => {
		getOrgans();
		if (removeSession.includes(systemLevelRole) === true) setCanRemove(true);
	}, []);

	const handleChangeFilter = ({ target }) => {
		let queryFilters = { ...filter };
		const { name, value } = target;
		queryFilters = { ...queryFilters, [name]: value };
		const params = new URLSearchParams();
		if (queryFilters.organ) params.set('organ', queryFilters.organ);
		if (queryFilters.startSessionDate)
			params.set('startSessionDate', queryFilters.startSessionDate);
		if (queryFilters.sessionNumber)
			params.set('sessionNumber', queryFilters.sessionNumber);
		if (queryFilters.endSessionDate)
			params.set('endSessionDate', queryFilters.endSessionDate);
		setFilter({ ...filter, [name]: value });
		history.push({ search: params.toString() });
	};

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true && filial === null) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const onConfirmFilter = () => {
		if (!filter.organ) {
			return notice('Debe Seleccionar un Órgano', 'danger');
		}

		let startSesion = '';
		let endSesion = '';

		filter.startSessionDate === null
			? (startSesion = '')
			: (startSesion = filter.startSessionDate.toLocaleDateString('en-GB'));

		filter.endSessionDate === null
			? (endSesion = '')
			: (endSesion = filter.endSessionDate.toLocaleDateString('en-GB'));

		setSessions([]);
		setLoading(true);
		sessionsAPI
			.getFilterSessions(
				filter.organ,
				filter.sessionNumber === undefined ? '' : filter.sessionNumber,
				startSesion,
				endSesion,
				pagination,
				currentPage
			)
			.then((response) => {
				if (response.sesiones && response.sesiones.length > 0) {
					setTotalResults(response.totalRegistros);
					notice('Filtrado en proceso', 'info');

					if (
						filter.sessionNumber === '' &&
						startSesion === '' &&
						endSesion === '' &&
						filter.organ !== ''
					)
						startLog(
							'Realizo busqueda de sesiones del organo colegiado: ' +
								response.sesiones[0]?.organoColegiado?.nombre
						);

					let respOrderly = response.sesiones.sort((a, b) => {
						var partes = a.fecha.split('-');
						var fa = new Date(partes[2], partes[1], partes[0]);
						partes = b.fecha.split('-');
						var fb = new Date(partes[2], partes[1], partes[0]);

						return fb - fa;
					});

					setSessions(respOrderly);
				} else {
					notice('No se encontraron resultados', 'warning');
				}
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				notice('Error en la solicitud');
			});
	};
	const onClear = () => {
		setFilter(defaultFilter);
		setSessions([]);
	};

	const onModalDelete = (id) => {
		setModalDelate(true);
		setIdSess(id);
	};

	const onDelete = () => {
		let newResponse = [];
		sessionsAPI
			.deleteSession(idSess)
			.then((response) => {
				if (systemLevelRole === 'RESPONSABLE DE ORGANO COLEGIADO')
					notice(
						'Se ha enviado solicitud de aprobacion para eliminar la sesion seleccionada.',
						'success'
					);
				else notice('Se elimino la sesión con exito', 'success');

				newResponse = sessions.filter((e) => {
					return e.id !== idSess;
				});
				setSessions(newResponse);

				if (response.codigo === 'SAOC-400' || response.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(response.mensaje)));
			})
			.catch((e) => {
				if (e?.response?.data?.mensaje === undefined)
					notice('Ocurrio un error con su petición');
				else notice(JSON.parse(JSON.stringify(e?.response?.data?.mensaje)));
			});
		setModalDelate(false);
		setIdSess();
	};

	const onEye = (id) => history.push(`/sesiones/consultar-sesiones/sesion/${id}`);

	useEffect(() => {
		if (location.search.length > 2) {
			const params = new URLSearchParams(location.search);
			const organ = params.get('organ') || '';
			const sessionNumber = params.get('sessionNumber') || '';
			/* 			const startSessionDate = params.get('startSessionDate') || null;
			const endSessionDate = params.get('endSessionDate') || null; */
			setFilter({
				...filter,
				organ: organ ? Number(organ) : '',
				sessionNumber,
				/* 				startSessionDate,
				endSessionDate, */
			});
		}
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			if ((filter.organ || filter.sessionNumber) && !mounted) {
				onConfirmFilter();
			}
			setMounted(true);
		}, 2000);
		return () => clearTimeout(timer);
	}, [filter]);

	useEffect(() => {
		if (mounted) {
			onConfirmFilter();
		}
	}, [pagination, currentPage]);

	return (
		<PageLayout>
			<FullTable
				isLoading={loading}
				title="Consultar Sesiones"
				items={sessions}
				count={sessions.length}
				columns={columns(onModalDelete, onEye, canRemove)}
				filtersWidth={210}
				filter={filter}
				filterForm={filterForm(onConfirmFilter, onClear, organs)}
				onFilterChange={handleChangeFilter}
				ExcelFileName={`Consulta_de_Sesiones ${formatDate('P p')}.xls`}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			<DeleteConsultModal
				open={modalDelete}
				setClose={setModalDelate}
				onDelete={onDelete}
			/>
		</PageLayout>
	);
};

export default ConsultSessions;
